import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DwDivMaskComponent } from './dw-div-mask.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DwDivMaskComponent
  ],
  exports: [
    DwDivMaskComponent
  ]
})
export class DwDivMaskModule {}
